export default __webpack_public_path__ + "static/logo-dark-icelandia-3289f56e6f269783476098756cd52a8d.svg";